import { render } from "./Index.vue?vue&type=template&id=d704ebd0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=d704ebd0&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=d704ebd0&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d704ebd0"]])

export default __exports__